import { usersApi } from 'entities/users/model/usersApi';
import { RoleType } from 'entities/users/types';

const getUserRolesApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserRoles: builder.query<RoleType[], any>({
      query: () => '/account/admin/dicts/user-roles/',
    }),
  }),
});

export const { useGetUserRolesQuery } = getUserRolesApi;
